<template lang="html">
  <div>
    <div class="login__atmosphere">
      <img :src="require('img/login/loginPassword.png')" />
    </div>
    <div class="login-form" v-on:keyup.enter="send">
      <h2 class="login-form__title">{{ $t('login.forgotPassword') }}</h2>
      <p class="login-form__text" v-if="!showSuccess">
        {{ forgotPasswordText }}
      </p>
      <p class="login-form__text" v-if="!showUsernameError && showSuccess">
        {{ forgotPasswordSuccessFirst + maxReset + $t('login.forgotPasswordSuccessSecond')}}
      </p>
      <p4a-input class="login-input"
                 v-if="!showSuccess"
                 :type="'text'"
                 :size="'large'"
                 :warning="{visible: showUsernameError, showIcon: true, message: 'Verplicht veld'}"
                 :valid="false"
                 :leftIcon="'user'"
                 :placeholder="usernamePlaceHolder"
                 v-model="username"
                 :fullWidth="true"
                 :autofocus="true"
                 v-on:keyup.native="removeWarning"/>
      <p4a-button class="login-button"
                  v-if="!showSuccess"
                  :showIcon="false"
                  :onlyIconVisible="false"
                  :product="'ds'"
                  :size="'large'"
                  :disable="false"
                  :fullWidth="true"
                  :text="$t('login.send')"
                  :borderColor="borderColor"
                  :hoverColor="hoverColor"
                  :backgroundColor="backgroundColor"
                  :hoverFontColor="hoverFontColor"
                  @click="send">
      </p4a-button>
      <div class="login-form__link">
        <router-link to="/login" class="login-form__link--section">{{ $t('login.back') }}</router-link>
      </div>
    </div>

    <p4a-toast />
  </div>
</template>

<script>
import * as usersAndGroupsApi from 'api/usersAndGroupsApi'
import * as settingsApi from 'api/settingsApi'

export default {
  name: 'ForgotPasswordInput',
  data () {
    return {
      falseUsername: false,
      username: null,
      passwordResetSettings: null,
      maxReset: null,
      linkDuration: null,
      showUsernameError: false,
      showSuccess: false,
      hoverColor: undefined,
      borderColor: undefined,
      backgroundColor: undefined,
      hoverFontColor: undefined,
      emailLogin: false
    }
  },
  methods: {
    removeWarning () {
      let self = this
      if (self.email !== '') {
        self.falseUsername = false
      }
    },
    send (event) {
      let self = this
      if (event) {
        event.preventDefault()
      }
      if (!this.username || this.username.length === 0) {
        this.showUsernameError = true
        this.showSuccess = false
        self.$p4aToast.show(this.$t('login.forgotPassword'), this.$t('login.forgotPasswordFail'), 'error', '3000')
      } else {
        if (this.emailLogin && !this.emailIsValid(this.username)) {
          this.showUsernameError = true
          this.showSuccess = false
          self.$p4aToast.show(this.$t('login.forgotPassword'), this.$t('login.forgotPasswordFailEmail'), 'error', '3000')
        } else {
          this.showUsernameError = false
          this.showSuccess = true
          settingsApi.getPasswordResetSettings().then(result => {
            if (result) {
              self.passwordResetSettings = result
              self.maxReset = self.passwordResetSettings.MaxCountResetLinkDay
              self.linkDuration = self.passwordResetSettings.ValidDurationLoginMinutes
            }
          })
          usersAndGroupsApi.forgotpassword({ username: this.username })
        }
      }
    },
    emailIsValid (email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
    }
  },
  computed: {
    forgotPasswordText () {
      return this.emailLogin ? this.$t('login.forgotPasswordTextWithEmail') : this.$t('login.forgotPasswordText')
    },
    forgotPasswordSuccessFirst () {
      return this.emailLogin ? this.$t('login.forgotPasswordSuccessFirstWithEmail') : this.$t('login.forgotPasswordSuccessFirst')
    },
    usernamePlaceHolder () {
      return this.emailLogin ? this.$t('login.usernameWithEmail') : this.$t('login.username')
    }
  },
  created () {
    let dsThemeColor = localStorage.getItem('ds-theme-color')
    if (dsThemeColor != null && dsThemeColor !== 'null') {
      this.borderColor = dsThemeColor
      this.hoverColor = dsThemeColor
    }
    let dsThemeFontColor = localStorage.getItem('ds-theme-font-color')
    if (dsThemeFontColor != null && dsThemeFontColor !== 'null') {
      this.backgroundColor = dsThemeFontColor
      this.hoverFontColor = dsThemeFontColor
    }
    let self = this
    settingsApi.getLoginSettings().then(result => {
      if (result) {
        self.emailLogin = result.UseEmailLogin
      }
    })
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/login/inputs/forgotPasswordInput.vue